import React, { useState } from 'react';
import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import { useLocation, useHistory } from 'react-router-dom';

import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import * as url from '../../helpers/url_helper';
import ExceptionTraceModal from '../../components/Log/ExceptionTraceModal';

function Exceptions() {
  const [selectedException, setSelectedException] = useState(null);
  const [showViewer, setShowViewer] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const openViewer = (row) => {
    const code = row.id;
    history.replace(`${location.pathname}?id=${encodeURIComponent(code)}`);
    setSelectedException(row);
    setShowViewer(true);
  };

  return (
    <div className="page-content log-exceptions-page">
      <div className="container-fluid">
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <CardTitle className="h4">Exceptions</CardTitle>

                <Can i="see" this="Log">
                  <BaseGrid
                    url={url.GET_LOG_EXCEPTIONS}
                    config={
                    {
                      columns: {
                        id: { label: 'ID', sort: true },
                        created_at: {
                          label: 'Date',
                          sort: true,
                          date: {
                            timezone: process.env.LOCAL_TZ,
                            format: (d) => d.toLocaleString(),
                          },
                        },
                        code: { label: 'Code', sort: true },
                        message: { label: 'Message', sort: true, link: { click: openViewer } },
                      },
                      pagination: {
                        sort: 'created_at',
                        direction: 'desc',
                        perPage: 10,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="Log"><p>Unauthorized</p></Can>
                <ExceptionTraceModal
                  shown={showViewer}
                  exception={selectedException}
                  onClose={() => setShowViewer(false)}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Exceptions;
